export function getIsActiveFile({ activeFileQuery, fileInProgress }) {
  return (
    activeFileQuery &&
    (!fileInProgress ||
      (fileInProgress && fileInProgress?.id === Number(activeFileQuery)))
  )
}
